import { useCallback } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallOneLineWithTimerProps } from './types';
import { isNil, isNotNil } from '../../../../utils';
import { useCountdown } from '../../../../hooks/useCountdown';
import { useOpenDeeplink } from '../../../../hooks';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';
import { ViewAllButton } from '../ViewAllButton';

export const HeadlineSmallOneLineWithTimer = ({
  header,
  screen,
}: HeadlineSmallOneLineWithTimerProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const { timeText: timerText } = useCountdown(header?.item.timer?.finished_at);

  const handlePressMore = useCallback(() => {
    if (isNil(header) || isNil(header.item.deeplink)) return;
    logAnalyticsEvent({
      name: 'CLICK_HEADLINE_SMALL_ONE_LINE_WITH_TIMER_MORE',
      analytics: {
        ...header.logging.analytics,
        ...(screen != null && { SCREEN: screen }),
      },
      ably_only_log: header.logging.ably_only_log,
    });
    openDeeplink(header.item.deeplink);
  }, [header, screen, openDeeplink, logAnalyticsEvent]);

  if (isNil(header)) return null;

  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row
      padding={{ top: 24, bottom: 16, left: 16, right: hasDeeplink ? 0 : 16 }}
      alignItems="center"
    >
      <Flex.Row flex={1} gap={4} alignItems="center">
        <Typography type="h5" color="content_primary" numberOfLines={1}>
          {header.item.title}
        </Typography>
        {isNotNil(timerText) && (
          <Typography type="h5" color="content_pink_primary">
            {timerText}
          </Typography>
        )}
      </Flex.Row>

      {hasDeeplink && (
        <Flex padding={{ right: 4 }}>
          <ViewAllButton
            testID={`${header.item.title}전체보기`}
            onPress={handlePressMore}
          />
        </Flex>
      )}
    </Flex.Row>
  );
};
